import { toast } from 'react-toastify';

export const toastOnError = <T, A extends any[] = []>(func: (...a: A) => Promise<T>, message?: string, fin?: () => void | Promise<void>) => {
  return async (...a: A) => {
    try {
      return await func(...a);
    }
    catch (error: any) {
      console.log(error);
      toast.error(message || error.message || error.reason || error.error || `${error}`);
    }
    finally {
      await fin?.();
    }
  };
};
